import API from "../api";

export const getWhatsAppSettings = () =>
  API.get("/admin/integrations/whatsapp").then((r) => r.data);

export const saveWhatsAppSettings = (payload) =>
  API.put("/admin/integrations/whatsapp", payload).then((r) => r.data);

export const getRecentWhatsAppQueue = () =>
  API.get("/admin/whatsapp/queue/recent").then((r) => r.data || []);

export const testWhatsAppSettings = (recipientPhone) =>
  API.post("/admin/integrations/whatsapp/test", null, {
    params: { recipientPhone },
  }).then((r) => r.data);

export const getStudentWhatsAppPreferences = () =>
  API.get("/student/whatsapp-preferences").then((r) => r.data);

export const saveStudentWhatsAppPreferences = (payload) =>
  API.put("/student/whatsapp-preferences", payload).then((r) => r.data);
